import React, { useMemo } from "react";

import { TableLoader } from "./tableLoader";

const defaultProps = {
	tableProps: {
		header: {},
		body: {},
		footer: {},
	},
};
type Props = {
	loading: boolean;
	variant: "table" | "input";
	children: any;
	tableProps?: typeof defaultProps.tableProps;
};

export const WithLoader = ({
	loading,
	variant,
	children,
	tableProps = defaultProps.tableProps,
}: Props) => {
	const skeletonsMap = useMemo(
		() => ({
			table: <TableLoader {...tableProps} />,
			input: <> </>, // Extend
		}),
		[tableProps],
	);

	var ChildrenWithLoader = useMemo(
		() => (loading ? skeletonsMap[variant] : children),
		[loading, skeletonsMap, variant, children],
	);

	return ChildrenWithLoader;
};
